import { pdf } from '@react-pdf/renderer';
import FormTemplate from '../components/MultiFormViewer/FormTemplate';
import { APP_TYPE_APPLICATION_PROCESS } from '../pages/ProgramSetup/subPages/StagesAndForms/constants';
import { DOMAIN } from './environmentUtils';
import { triggerConditionCheck } from './conditionalLogic';

export function generateUUID() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		const r = (Math.random() * 16) | 0,
			v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}

export const compareMultiLevelArray = (a, b) => {
	let isEqual = JSON.stringify(a) === JSON.stringify(b);
	return isEqual;
};

export function reOrderRows(orderArr, rows) {
	let orderedValues = orderArr?.map((e) => rows?.find((x) => x?.appId === e || x?.form_id === e));
	let unorderedValues = rows?.filter((e) => !orderArr?.includes(e?.appId || e?.form_id));

	orderedValues = orderedValues?.filter((value) => value !== undefined) || [];
	unorderedValues = unorderedValues?.filter((value) => value !== undefined) || [];

	return [...orderedValues, ...unorderedValues];
}

export function removeDuplicates(arr) {
	const unique = {};
	const result = [];

	for (const obj of arr) {
		if (!unique[obj.appId]) {
			result.push(obj);
			unique[obj.appId] = true;
		}
	}

	return result;
}

export function onlySubpageRows(arr, subPage) {
	const finalArray = arr?.filter((e) => e?.hierarchy?.includes(subPage));
	return finalArray;
}

export function is_within_range(masterStage, overrideDates) {
	if (overrideDates) {
		return true;
	}

	if (masterStage) {
		const currentDate = new Date();
		const startDate = new Date(masterStage.start_date);
		const endDate = new Date(masterStage.end_date);

		if (currentDate >= startDate && currentDate <= endDate) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
}

export const checkOverflow = (e) => {
	const el = e?.target;
	var curOverflow = el.style.overflow;
	if (!curOverflow || curOverflow === 'visible') el.style.overflow = 'hidden';

	var isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

	el.style.overflow = curOverflow;
	return isOverflowing;
};

export const hideIFrameContent = () => {
	const removedClasses = [
		'navbar-toolbar',
		'sidenav-drawer',
		'programs-title',
		'breadcrumbs-links-container',
		'individualprograms-box'
	];
	document.querySelector(`[data-testid=baseLayout-mainContent]`).style.marginTop = '0px';
	removedClasses?.forEach((id) => {
		const element = document?.querySelector(`[data-testid=${id}]`);

		if (element) {
			element.style.display = 'none';
		}
	});
};

export const setPencilIcon = (readOnly) => {
	const breadCrumbPencilIcon = document.getElementById('breadcrumbs-link-pencilIcon');
	if (!readOnly && breadCrumbPencilIcon) {
		breadCrumbPencilIcon.style.display = 'block';
	} else if (readOnly && breadCrumbPencilIcon?.style?.display === 'block') {
		breadCrumbPencilIcon.style.display = 'none';
	}
};

export const isDecisionChip = (value) => ['Rec for Award', 'On Hold', 'Rejected'].includes(value);

export const getStatusColor = (status) => {
	const colorMap = {
		Published: 'rgba(56, 142, 60, 1)',
		Draft: 'rgba(144, 164, 174,1)',
		Closed: 'rgba(69, 90, 100, 1)',
		Archived: 'rgba(0, 0, 0, 1)',
		'Ready to Publish': 'rgba(54, 83, 205, 1)',
		Finalized: 'rgba(54, 83, 205, 1)',
		'In Review': 'rgba(54, 83, 205, 1)',
		'Not Started': 'rgba(144, 164, 174,1)',
		'Rec for Award': 'rgba(41, 182, 246, 1)',
		'In Progress': 'rgba(156, 39, 176, 1)',
		'In Progress (returned)': 'rgba(123, 31, 162, 1)',
		'In Progress (paused)': 'rgba(123, 31, 162, 1)',
		'In Progress (reopened)': 'rgba(156, 39, 176, 1)',
		'Draft (reopened)': 'rgba(144, 164, 174,1)',
		'Draft (paused)': 'rgba(144, 164, 174,1)',
		'Draft (returned)': 'rgba(144, 164, 174,1)',
		'Pending Decision': 'rgba(27, 93, 32, 1)',
		Submitted: 'rgba(56, 142, 60, 1)',
		'Submission Incomplete': 'rgba(255, 68, 97, 1)',
		'Submission Pending': 'rgba(144, 164, 174,1)',
		'Review Incomplete': 'rgba(255, 68, 97, 1)',
		Unassigned: 'rgba(252, 186, 3,1)',
		Completed: 'rgba(102, 187, 106, 1)',
		Denied: 'rgba(235, 64, 52,1)',
		White: 'rgba(255, 255, 255, 1)',
		Assigned: '#E0F7FA',
		Sent: '#E0F7FA',
		'Under Consideration': 'rgba(27, 93, 32, 1)',
		'Under Review': 'rgba(54, 83, 205,1)',
		'On Hold': '#FF9800',
		'Invitation Accepted': '#4CAF50',
		Accepted: '#4CAF50',
		'Invitation Rejected': 'rgba(235, 64, 52,1)',
		Rejected: 'rgba(235, 64, 52,1)',
		default: 'rgba(144, 164, 174,1)'
	};

	return colorMap[status] || colorMap['default'];
};

export const appStagesCompletedAndAfter = [
	'Completed',
	'Rec. Award',
	'On Hold',
	'Pending Decision',
	'Denied'
];

export const getEcivisBlueColor = (alpha) => (!alpha ? '#009DAC' : `rgba(0, 157, 172, ${alpha})`);

export const getEunaOrangeColor = (alpha) => (!alpha ? '#FF6E14' : `rgb(255, 110, 20, ${alpha})`);

export const getOldBlueColor = (alpha) => (!alpha ? '#1976D2' : `rgba(25, 118, 210, ${alpha})`);

export const getChipTextColor = (value) => {
	value = value?.toLowerCase();
	if (['unassigned', 'assigned', 'sent'].includes(value)) {
		return 'black';
	} else if (value?.includes('archived')) {
		return '#90A4AE';
	} else {
		return 'white !important';
	}
};

export const getApplicationPageTitle = (props) => {
	const { appId, title, applicationStageID, reviewer } = props;

	if (appId?.includes('rst-')) {
		return `${title}`;
	}
	if (appId?.includes('arr-')) {
		return `${title} [${appId}] | ${reviewer}`;
	}
	if (appId?.includes('afa-')) {
		return `Application [${applicationStageID}] | ${title} [${appId}]`;
	}
	if (appId?.includes('rvf-')) {
		return `${title} | [${appId}]`;
	}
	if (appId?.includes('sst-')) {
		return `${title}`;
	} else {
		return `Application [${applicationStageID}]`;
	}
};

export function removeHttpVariations(string) {
	// Remove variations of 'https://'
	string = string.replace(/https:\/\/|https:\/\//g, '');

	// Remove variations of 'http://'
	string = string.replace(/http:\/\/|http:\/\//g, '');

	// Remove variations of 'http//'
	string = string.replace(/http\/\//g, '');

	return string;
}

export function getEntityPrefix({
	type,
	isProgram,
	isAdHoc,
	isBaseTemplate,
	isMaters,
	isInstance
}) {
	if (isProgram) return 'p-';

	if (isAdHoc) {
		switch (type) {
			case 'application-form':
				return 'aaft-';
			case 'review-form':
				return 'arft-';
		}
	}

	if (isBaseTemplate) {
		switch (type) {
			case 'Application Process':
			case 'application-process':
				return 'apt-';
			case 'Submission Stage':
			case 'submission-stage':
				return 'sst-';
			case 'Application Form':
			case 'application-form':
				return 'baft-';
			case 'Evaluation Stage':
			case 'evaluation-stage':
				return 'est-';
			case 'Review Form':
			case 'review-form':
				return 'brft-';
		}
	}

	if (isMaters) {
		switch (type) {
			case 'application-process':
			case 'Application Process':
				return 'apm-';
			case 'submission-stage':
			case 'Submission Stage':
				return 'ssm-';
			case 'application-form':
			case 'Application Form':
				return 'afm-';
			case 'Evaluation Stage':
			case 'evaluation-stage':
				return 'esm-';
			case 'Review Form':
			case 'review-form':
				return 'rfm-';
		}
	}

	if (isInstance) {
		switch (type) {
			case 'application-process':
				return 'api-';
			case 'submission-stage':
				return 'ssi-';
			case 'application-form':
				return 'afi-';
			case 'evaluation-stage':
				return 'esi-';
			case 'review-form':
				return 'rfi-';
		}
	}
}

export const calculateMasterFormCompletion = (arr) => {
	const finalArray = arr?.map((e) => {
		if (e?.type === 'Review Form(s)') {
			let totalForms = 0;
			let completedForms = 0;
			let notStartedForms = 0;

			arr?.forEach((x) => {
				if (x?.hierarchy?.includes(e?.appId) && x?.type !== 'Review Form(s)') {
					totalForms++;
					x?.status === 'Completed' && completedForms++;
				}
			});

			e['status'] = totalForms === completedForms ? 'Completed' : e?.status;
			e['status'] = totalForms === notStartedForms ? 'Not Started' : e?.status;
			e['status'] = totalForms === 0 ? 'Unassigned' : e?.status;
			e['completion'] = `${
				completedForms > 0 ? Math.floor((completedForms / totalForms) * 100) : 0
			}%`;
			return e;
		} else {
			return e;
		}
	});
	return finalArray;
};

export function getUniqueValues(arrays) {
	const uniqueValues = new Set();

	arrays.forEach((array) => {
		array.forEach((value) => {
			uniqueValues.add(value);
		});
	});

	return Array.from(uniqueValues);
}

export function getUniqueValuesFromObject(object) {
	const allArrays = Object.values(object).flat();
	const uniqueArray = [...new Set(allArrays)];
	return uniqueArray;
}

export const checkProcessValidDates = (setupRows) => {
	const invalidEntities = [];
	const requiresDate = [APP_TYPE_APPLICATION_PROCESS];

	setupRows?.forEach((e) => {
		if (requiresDate.includes(e?.type)) {
			if (!e?.startDate || !e?.endDate) {
				invalidEntities?.push(e?.uniqueIdentifier);
			}
		}
	});

	return invalidEntities;
};

export const checkHiddenFields = (formSchemas, formAnswers) => {
	for (const formAnswer of formAnswers) {
		const matchingFormSchema = formSchemas?.find(
			(formSchema) => formAnswer.field === formSchema.field_id
		);
		if (matchingFormSchema) {
			const search_name = getNameBasedOnFieldName(
				matchingFormSchema.field_name,
				matchingFormSchema
			);
			const [sortableItemParent] = getSortableItemContainer(search_name);
			formAnswer.is_hidden = checkElementHiddenClass(sortableItemParent);
		}
	}
};

/**
 * Get the correct name of the field based on how it appears in the DOM.
 *
 * @param {string} fieldName - the name of the field
 * @param {object} [field] - the field object, which contains the options
 */
export const getNameBasedOnFieldName = (fieldName, field) => {
	let search_name = fieldName;

	if (search_name?.includes('linkInput_')) {
		// Try to match what's actually rendered in the DOM
		if (document.getElementsByName(`${search_name}-title`)?.length > 0) {
			search_name = `${search_name}-title`;
		} else {
			search_name = `${search_name}-link`;
		}
	}

	if (search_name?.includes('mui_startend_')) {
		search_name = search_name + '-start';
	}

	if (search_name?.includes('mui_checkbox_') || search_name?.includes('mui_radiobutton_')) {
		const optionKey = field?.options[0]?.key || '';
		search_name = `option_${optionKey}`;
	}

	return search_name;
};

/**
 * Get the sortable item container based on the child input name.
 *
 * @param {string} childInputName - the name of the child input
 * @returns {Array} - an array containing the possible input container and the input element
 */
export const getSortableItemContainer = (childInputName) => {
	const inputElement = document.getElementsByName(childInputName);
	const possibleInputContainer = inputElement?.[0]?.closest('.SortableItem');

	return [possibleInputContainer, inputElement];
};

export const checkAnswerConditions = (formItem, formAnswers) => {
	const dependencies = formItem?.dependency;

	// Return true if dependencies are undefined or empty
	if (!dependencies || dependencies.length === 0) {
		return true;
	}

	const conditionsMet = dependencies?.map((dependency) => {
		const dependentAnswer = formAnswers?.find((answer) => answer.name === dependency.field);
		return triggerConditionCheck(dependency.condition, dependentAnswer?.value, dependency);
	});
	return conditionsMet && conditionsMet.every((conditionMet) => conditionMet === true);
};

export const validateRequiredFields = (formSchema, formAnswers, rendered = true) => {
	if (!formSchema) {
		return [];
	}

	let errors = [];

	for (const formItem of formSchema) {
		let matchingAnswer;
		let id;
		if ('field_id' in formItem) {
			matchingAnswer = formAnswers?.find((answer) => answer.field === formItem.field_id);
			id = formItem.field_id;
		} else {
			matchingAnswer = formAnswers?.find((answer) => answer.name === formItem.field_name);
			id = formItem.id;
		}

		// Check if required field has no answer at all
		if (!matchingAnswer && formItem?.required) {
			const search_name = getNameBasedOnFieldName(formItem.field_name, formItem);
			const [sortableItemContainer] = getSortableItemContainer(search_name);

			if (rendered) {
				// Skip if the field is hidden due to unmet dependencies
				if (checkElementHiddenClass(sortableItemContainer)) continue;
			} else {
				// Skip if the field has a dependency that has not been satisfied
				if (!checkAnswerConditions(formItem, formAnswers)) continue;
			}

			// Required field with no answer is an error
			errors.push({
				id,
				field_name: formItem.field_name,
				label: formItem.label,
				error: `is required`
			});
			continue;
		}

		if (matchingAnswer && formItem?.required) {
			const search_name = getNameBasedOnFieldName(formItem.field_name, formItem);
			const [sortableItemContainer] = getSortableItemContainer(search_name);

			if (rendered) {
				// works only when fields are rendered
				// the field is currently not showing meaning the dependency is not satisfied
				if (checkElementHiddenClass(sortableItemContainer)) continue;
			} else {
				// field has a dependency that has not been satisfied
				if (!checkAnswerConditions(formItem, formAnswers)) continue;
			}

			if (formItem.element == 'Signature') {
				if (matchingAnswer?.value?.length === 0) {
					errors.push({
						id,
						field_name: formItem.field_name,
						label: formItem.label,
						error: `is required`
					});
				}
			} else {
				switch (formItem.key) {
					case 'MUI_LinkInput':
						const requiresTitle = !formItem?.custom_options?.includes('editOnlyLink');
						const isTitleMissing = matchingAnswer?.value[0]?.length === 0;
						const isLinkMissing = matchingAnswer?.value[1]?.length === 0;
						if (
							(requiresTitle && (isTitleMissing || isLinkMissing)) ||
							(!requiresTitle && isLinkMissing)
						) {
							const linkFieldName = getNameBasedOnFieldName(formItem.field_name, formItem);
							errors.push({
								id,
								field_name: linkFieldName,
								label: formItem.label,
								error: `is required`
							});
						}
						break;
					case 'MUI_StartEndDate':
						if (matchingAnswer?.value[0]?.length === 0 || matchingAnswer?.value[1]?.length === 0) {
							errors.push({
								id,
								field_name: `${formItem.field_name}-start`,
								label: formItem.label,
								error: `is required`
							});
						}
						break;
					case 'MUI_FileUpload':
					case 'MUI_Rating':
					case 'StatePicker':
					case 'MUI_Dropdown':
					case 'MUI_Tags':
						if (matchingAnswer?.value?.length === undefined || matchingAnswer?.value.length === 0) {
							errors.push({
								id,
								field_name: `${formItem.field_name}`,
								label: formItem.label,
								error: `is required`
							});
						}
						break;
					case 'MUI_RadioButton':
					case 'MUI_Checkbox':
						if (matchingAnswer?.value?.length === 0) {
							errors.push({
								id,
								field_name: `option_${formItem.options[0]?.key}`,
								label: formItem.label,
								error: `is required`
							});
						}
						break;
					case 'MUI_DatePicker':
					case 'MUI_NumberInput':
					case 'MUI_TextArea':
					case 'MUI_Input':
					case 'MUI_Email':
					case 'MUI_PhoneNumber':
						if (matchingAnswer?.value?.length === 0) {
							errors.push({
								id,
								field_name: `${formItem.field_name}`,
								label: formItem.label,
								error: `is required`
							});
						}
						break;
					default:
						break;
				}
			}
		}
	}
	return errors;
};

export const validateDate = (date) => {
	const dateParts = date.split('/');

	if (dateParts.length !== 3) {
		return false;
	}
	const [month, day, year] = dateParts;
	const dateObj = new Date(year, month - 1, day);
	return (
		dateObj.getFullYear() == year && dateObj.getMonth() == month - 1 && dateObj.getDate() == day
	);
};

export const validateISODate = (dateStr) => {
	if (!dateStr || typeof dateStr !== 'string') return false;
	const isoMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
	if (isoMatch) {
		const [, year, month, day] = isoMatch;
		const dateObj = new Date(year, month - 1, day);
		return (
			dateObj.getFullYear() === Number(year) &&
			dateObj.getMonth() === Number(month) - 1 &&
			dateObj.getDate() === Number(day)
		);
	}
	return validateDate(dateStr);
};

/**
 * Check if the element has the hidden-dependency class.
 *
 * @param {HTMLElement} element - the element to check
 * @returns {boolean} - whether the element has the hidden-dependency class
 */
export const checkElementHiddenClass = (element) => {
	return !!element?.classList?.value?.includes('hidden-dependency');
};

export const areRequiredFieldsTested = (formSchema, formAnswers) => {
	for (const formItem of formSchema) {
		const matchingAnswer = formAnswers.find((answer) => answer.name === formItem.field_name);
		if (matchingAnswer && formItem.required) {
			if (formItem.element == 'Signature') {
				if (typeof matchingAnswer.value === 'undefined') return false;
				if (matchingAnswer.value.length === 0) return false;
			} else {
				switch (formItem.key) {
					case 'StatePicker':
					case 'MUI_Dropdown':
					case 'MUI_FileUpload':
						if (typeof matchingAnswer.value === 'undefined') return false;
						if (matchingAnswer.value === null) return false;
						if (matchingAnswer.value.length === 0) return false;
						if (matchingAnswer.value == '') return false;
						break;
					case 'MUI_LinkInput': {
						const requiresTitle = !formItem?.custom_options?.includes('editOnlyLink');
						const isTitleMissing = matchingAnswer.value[0].length === 0;
						const isLinkMissing = matchingAnswer.value[1].length === 0;
						if (
							(requiresTitle && (isTitleMissing || isLinkMissing)) ||
							(!requiresTitle && isLinkMissing)
						)
							return false;
						break;
					}
					case 'MUI_StartEndDate':
						if (matchingAnswer.value[0].length === 0 || matchingAnswer.value[1].length === 0)
							return false;
						break;
					case 'MUI_RadioButton':
					case 'MUI_DatePicker':
					case 'MUI_Rating':
					case 'MUI_Checkbox':
					case 'MUI_NumberInput':
					case 'MUI_TextArea':
					case 'MUI_Input':
					case 'MUI_Email':
					case 'MUI_PhoneNumber':
						if (typeof matchingAnswer.value === 'undefined') return false;
						if (matchingAnswer.value.length === 0) return false;
						break;
					default:
						break;
				}
			}
		}
	}
	return true;
};

export const sanitizeBlob = (blob) => {
	if (!(blob instanceof Blob)) {
		throw new Error('Invalid blob object');
	}

	const validMimeTypes = [
		'application/msword', // .doc
		'application/pdf',
		'application/vnd.ms-excel', // .xls
		'application/vnd.oasis.opendocument.spreadsheet', // .ods
		'application/vnd.oasis.opendocument.text', // .odt
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
		'application/x-7z-compressed', // .7zip
		'application/zip',
		'image/gif',
		'image/jpeg',
		'image/png',
		'text/csv',
		'text/plain' // .txt
	];

	const sanitizedType = blob.type.toLowerCase().trim();

	if (!validMimeTypes.includes(sanitizedType)) {
		throw new Error('Unsupported file type');
	}

	// List of binary MIME types that should not be re-wrapped
	const binaryMimeTypes = [
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
		'application/pdf',
		'application/msword',
		'application/vnd.ms-excel',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
		'application/zip',
		'application/x-7z-compressed'
	];

	if (binaryMimeTypes.includes(sanitizedType)) {
		// Use the original blob for binary files
		return window.URL.createObjectURL(blob);
	}

	// For text files, re-wrap if needed
	return window.URL.createObjectURL(new Blob([blob], { type: sanitizedType }));
};

const SAFE_BLOB_URL_REGEX = /^blob:(?:https?:\/\/[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=]*|null)$/;

const sanitizeBlobUrl = (url) => {
	if (!url || typeof url !== 'string') {
		throw new Error('Invalid blob URL');
	}

	if (!SAFE_BLOB_URL_REGEX.test(url)) {
		throw new Error('Invalid blob URL format');
	}

	try {
		const parsed = new URL(url);
		const origin = parsed.origin;
		const allowedOrigins = [window.location.origin, 'null'];

		if (!allowedOrigins.includes(origin)) {
			throw new Error('Invalid blob URL origin');
		}

		return url;
	} catch (e) {
		throw new Error(`Invalid blob URL: ${e.message}`);
	}
};

export const createAndDownloadFile = (blob, fileName) => {
	const sanitizedBlob = sanitizeBlob(blob);
	const sanitizedURL = sanitizeBlobUrl(sanitizedBlob);

	const a = document.createElement('a');
	a.href = sanitizedURL;
	a.download = fileName;
	a.style.display = 'none';
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(sanitizedURL);
};

function stripHTML(html) {
	const doc = new DOMParser().parseFromString(html, 'text/html');
	return doc.body.textContent || '';
}

export const sanitizePathname = (path) => {
	// Only allow alphanumerics, slashes, hyphens, and underscores
	return String(path).replace(/[^a-zA-Z0-9/_-]/g, '');
};

/**
 * Strip leading 'option_' prefix used by some DOM field names.
 * @param {string} val
 * @returns {string}
 */
export const stripOptionPrefix = (val) =>
	typeof val === 'string' && val?.startsWith('option_') ? val.substring(7) : val;

/**
 * Resolve an option display label from a list of options.
 * Tries common identifier properties and finally a loose substring search.
 * @param {Array} options - The options array from the field schema
 * @param {string|number} raw - The raw stored value (may include 'option_' prefix)
 * @returns {string}
 */
export const findOptionText = (options, raw) => {
	if (!options || raw == null) return '';
	const candidate = String(raw).trim();
	const lc = candidate.toLowerCase();
	const candidateNoPrefix = stripOptionPrefix(candidate);
	const propsToTry = ['key', 'value', 'id', 'field_id', 'option_id'];
	let match = options.find((o) => {
		return propsToTry.some((prop) => {
			if (o?.[prop] == null) return false;
			const v = String(o[prop]).trim();
			return (
				v === candidate ||
				v === candidateNoPrefix ||
				v.toLowerCase() === lc ||
				v.toLowerCase() === candidateNoPrefix.toLowerCase()
			);
		});
	});
	if (!match) {
		const cands = [candidate, candidateNoPrefix, lc, candidateNoPrefix.toLowerCase()];
		match = options.find((o) => {
			return Object.values(o || {}).some((vv) => {
				if (vv == null) return false;
				const s = String(vv).toLowerCase();
				return cands.some((c) => s.includes(String(c).toLowerCase()));
			});
		});
	}
	return match?.text ?? match?.label ?? candidateNoPrefix;
};

export const cleanUploadedFileName = (input) => {
	if (input == null) return '';
	const s = String(input);
	const looksLikeUrl =
		/:\/\//.test(s) ||
		s.startsWith('blob:') ||
		s.startsWith('data:') ||
		s.startsWith('http://') ||
		s.startsWith('https://');
	const base = looksLikeUrl ? s.split('?')[0].split('#')[0] : s;

	// Always reduce to the last path segment for paths/URLs
	const last = base.split('\\').pop().split('/').pop();

	// Remove UUID prefixes like <uuid>-filename.ext or <uuid>_filename.ext
	const uuidPrefix =
		/^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})[-_](.+)$/;
	const m = last.match(uuidPrefix);
	return m ? m[2] : last;
};

export const extractFilename = (val) => {
	if (val == null) return '';
	if (Array.isArray(val)) {
		return val.map(extractFilename).filter(Boolean).join(' - ');
	}
	if (typeof val === 'string') {
		try {
			const parsed = JSON.parse(val);
			return extractFilename(parsed) || cleanUploadedFileName(val);
		} catch {
			return cleanUploadedFileName(val);
		}
	}
	if (typeof val === 'object') {
		const candidate =
			val?.filename ||
			val?.name ||
			val?.original ||
			val?.original_filename ||
			val?.file ||
			val?.path;
		return candidate ? cleanUploadedFileName(candidate) : '';
	}
	return cleanUploadedFileName(String(val));
};

const MAX_PERCENTAGE_DIGITS_EXPORT = 12;

const coerceToString = (value) => {
	if (value === null || value === undefined) {
		return '';
	}
	return String(value);
};

const trimDecimalSuffix = (value) => {
	const stringValue = coerceToString(value);
	if (!stringValue.includes('.')) {
		return stringValue;
	}
	return stringValue.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');
};

const formatPercentageDisplay = (raw) => {
	const original = coerceToString(raw).trim();
	if (original === '') {
		return '';
	}
	const cleaned = original.replace(/,/g, '').trim();
	const hadPercent = cleaned.includes('%');
	const numericPart = cleaned.replace(/%/g, '');
	const sanitized = numericPart.replace(/[^0-9.\-+]/g, '');
	const parts = sanitized.split('.');
	let normalizedNumeric = sanitized;
	if (parts.length > 2) {
		normalizedNumeric = `${parts.shift()}.${parts.join('')}`;
	}
	if (normalizedNumeric.length > MAX_PERCENTAGE_DIGITS_EXPORT) {
		normalizedNumeric = normalizedNumeric.slice(0, MAX_PERCENTAGE_DIGITS_EXPORT);
	}
	const numericValue = Number(normalizedNumeric);
	if (Number.isNaN(numericValue)) {
		return cleaned.endsWith('%') ? cleaned : `${cleaned}%`;
	}

	const decimalValue = hadPercent ? numericValue / 100 : numericValue;
	const rawComponent = trimDecimalSuffix(decimalValue.toFixed(12));
	const percentComponent = trimDecimalSuffix((decimalValue * 100).toFixed(6));
	return `${rawComponent} (${percentComponent}%)`;
};

const formatCurrencyDisplay = (raw) => {
	const stringValue = coerceToString(raw).trim();
	if (stringValue === '') {
		return '';
	}
	const cleaned = stringValue.replace(/[^0-9.-]/g, '');
	if (cleaned === '' || cleaned === '-' || cleaned === '.' || cleaned === '-.') {
		return stringValue;
	}
	const numeric = Number(cleaned);
	if (Number.isNaN(numeric)) {
		return stringValue;
	}
	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD'
	}).format(numeric);
};

/**
 * Convert a raw stored field value into a printable label for PDFs.
 * Handles Dropdowns, Radio/Checkbox, and Signature fields ("Contains signature").
 * @param {object} schema - Field schema definition
 * @param {any} raw - Raw stored value (string|number|array|null)
 * @returns {string}
 */
export const toDisplayValue = (schema, raw) => {
	if (schema?.element === 'Signature' || schema?.field_name?.includes('signature_')) {
		return raw ? 'Yes' : 'No';
	}

	const isDropdownLike =
		schema?.key?.includes('Dropdown') ||
		schema?.key === 'StatePicker' ||
		schema?.element === 'Dropdown';
	const isChoiceLike =
		schema?.key?.includes('RadioButton') ||
		schema?.key?.includes('Checkbox') ||
		schema?.element === 'RadioButtons' ||
		schema?.element === 'Checkboxes';

	if (schema?.key === 'MUI_FileAttachment') {
		const src = schema?.src || schema?.props?.src;
		return extractFilename(src);
	}

	if (schema?.key === 'MUI_FileUpload') {
		return extractFilename(raw);
	}

	if (Array.isArray(raw)) {
		if (isChoiceLike) {
			const labels = raw
				.filter((x) => x != null)
				.map((x) => stripOptionPrefix(x))
				.map((x) => findOptionText(schema?.options, x));
			return labels.join(' - ');
		}
		return raw.map((x) => (x == null ? '' : String(x))).join(' - ');
	}

	if (typeof raw === 'string' || typeof raw === 'number') {
		if (schema?.key === 'MUI_NumberInput') {
			if (schema?.description === 'currency') {
				return formatCurrencyDisplay(raw);
			}
			if (schema?.description === 'percentage') {
				return formatPercentageDisplay(raw);
			}
		}

		const value = stripOptionPrefix(String(raw));
		if (isDropdownLike || isChoiceLike) {
			return findOptionText(schema?.options, value);
		}
		return value;
	}

	return raw ?? '';
};

export const exportFormToPDF = async (
	apiFormData,
	applicationStatus = '',
	applicationID = '',
	isEmptyForm
) => {
	const form = isEmptyForm ? apiFormData : apiFormData.form;

	const sanitizedApplicationID = applicationID?.replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 64);

	const formData = {
		programTitle: form.program?.project_title || '',
		programID: form.program?.id || '',
		label: form.label,
		applicationID: sanitizedApplicationID,
		instructions: stripHTML(form.instructions)
	};

	const rows = [];

	const fieldAddedToExport = (fieldId) =>
		rows.find((row) => row.fieldId.toUpperCase() === fieldId.toUpperCase());

	const addFieldToExport = (schema, isSectionLabel, rowValue) => {
		let label = schema.label || schema.text;
		label = schema?.key === 'MUI_Calculator' ? 'Total' : label;

		rows.push({
			label,
			isSectionLabel,
			required: !!schema.required,
			value: rowValue,
			fieldId: schema.field_id
		});
	};

	apiFormData.form_schema.forEach((schema) => {
		if (!fieldAddedToExport(schema.field_id)) {
			if (schema.group_name === 'Layout') {
				if (schema.child_items) {
					schema.child_items.forEach((child_schema_id) => {
						// it is currently possible to save layout components with empty children, which
						// will cause the list of child_items to be something like [null, null, null]. we
						// need to check if the child ID actually exists because of that
						if (child_schema_id) {
							const child_schema = apiFormData.form_schema.find(
								(inner_schema) =>
									inner_schema.field_id.toUpperCase() === child_schema_id.toUpperCase()
							);

							if (child_schema && !fieldAddedToExport(child_schema.field_id)) {
								if (isEmptyForm) {
									addFieldToExport(child_schema, false, '');
								} else {
									const fieldValue = apiFormData.field_values?.find(
										(field) => field.field.toUpperCase() === child_schema_id.toUpperCase()
									);

									if (fieldValue) {
										let value = fieldValue.value;

										if (
											child_schema.label === 'Application' &&
											child_schema.custom_options &&
											child_schema.custom_options.includes('not-editable') &&
											child_schema.custom_options.includes('core-application')
										) {
											value = `${applicationStatus} [api-${sanitizedApplicationID}]`;
										} else {
											value = toDisplayValue(child_schema, value);
										}

										addFieldToExport(child_schema, false, value);
									} else if (child_schema?.key === 'MUI_FileAttachment') {
										const value = toDisplayValue(child_schema, null);
										if (value !== undefined) {
											addFieldToExport(child_schema, false, value);
										}
									}
								}
							}
						}
					});
				} else if (schema.field_name.includes('groupingStart')) {
					addFieldToExport(schema, true, '');
				}
			} else if (schema.group_name === 'Controls') {
				if (isEmptyForm) {
					addFieldToExport(schema, false, '');
				} else {
					const fieldValue = apiFormData.field_values?.find(
						(field) => field.field.toUpperCase() === schema.field_id.toUpperCase()
					);

					if (fieldValue) {
						let value = toDisplayValue(schema, fieldValue.value);
						addFieldToExport(schema, false, value);
					} else if (schema?.key === 'MUI_FileAttachment') {
						const value = toDisplayValue(schema, null);
						addFieldToExport(schema, false, value);
					}
				}
			}
		}
	});

	const blob = await pdf(<FormTemplate formData={formData} rows={rows} />).toBlob();
	const fileName = `${form.label}${isEmptyForm ? ' Blank Form' : ''}.pdf`;

	createAndDownloadFile(blob, fileName);
};

const stringLenMax = 17; // default value if nothing passed

export const stringLengthMax = stringLenMax;

export const truncateString = (data, maxLength = stringLenMax) => {
	return data ? (data.length > maxLength ? data.slice(0, maxLength - 1) + '...' : data) : '';
};

export const getCookie = (name) => {
	return document.cookie.split('; ').reduce((accumulator, currentValue) => {
		const parts = currentValue.split('=');
		return parts[0] === name ? decodeURIComponent(parts[1]) : accumulator;
	}, '');
};
export const deleteCookie = (name) => {
	document.cookie = `${name}=; Secure; SameSite=None; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${DOMAIN};`;
};

export const isEmptyRTE = (value) => {
	if (typeof value === 'undefined') {
		return true;
	} else {
		return value && value.replace(/<[^>]*>/g, '') === '';
	}
};

export const getElementTitle = (elementData) => {
	if (elementData.group_name === 'Upload/Download' || elementData.group_name === 'Controls')
		return elementData.text;

	if (elementData.element === 'CustomElement') return elementData?.label || elementData.key;

	if (elementData.group_name === 'Typography') {
		if (elementData.element === 'HyperLink') return 'Website';
		return elementData.element;
	}

	return elementData.text;
};
